import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import TabelHeader from './components/TabelHeader.vue';
import EditTable from './components/EditTable.vue';
import TabelToolBar from './components/TabelToolBar';
import { ExportBoxCodeData } from '@/api/DeliveryCode';
import util from '@/libs/util';
export default {
  components: {
    TabelHeader: TabelHeader,
    EditTable: EditTable,
    TabelToolBar: TabelToolBar
  },
  data: function data() {
    return {
      isShowTabelHeader: false,
      TabelHeaderData: null,
      onSaveID: null
    };
  },
  methods: {
    // 明细导出
    onHandleDetailExport: function onHandleDetailExport() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  MST_ID: _this.onSaveID ? _this.onSaveID : _this.$refs.TabelHeader.getData().ID,
                  BARCODE_TYPE: 1 // Page:1,
                  // Limit:999

                };
                _context.next = 3;
                return ExportBoxCodeData(params);

              case 3:
                res = _context.sent;

                if (res.code === 0) {
                  window.open(_this.$store.getters.getVUE_APP_DOWN + res.data);
                } else {
                  _this.$message.warning('数据导出失败----' + res.message);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // cb切换单据
    cbNextOrder: function cbNextOrder(info, STATUS) {
      console.log('info', info);
      console.log('STATUS', STATUS);
      this.onSaveID = info.ID;
      this.$refs.EditTable.GetBoxCodeDetailPrintData(info);
      this.$refs.TabelToolBar.setStatus(STATUS);
    },
    // 上一张
    getBackOrder: function getBackOrder() {
      this.$refs.TabelHeader.getBackUpdata();
    },
    // 下一张
    nextOrder: function nextOrder() {
      this.$refs.TabelHeader.nextOrderUpdata();
    },
    // 保存成功ID回调
    cbID: function cbID(id) {
      this.onSaveID = id;
      this.$refs.EditTable.setID(id);
    },
    // 组合打印外箱标签
    onPrintOuterBoxLabel_OuterBoxLabelManagement: function onPrintOuterBoxLabel_OuterBoxLabelManagement() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, vali;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // this.$refs.TabelHeader.PrintOuterBoxLabel()
                id = _this2.onSaveID ? _this2.onSaveID : _this2.TabelHeaderData.ID;
                _context2.next = 3;
                return _this2.$refs.EditTable.valiPrintParBarcodeGroup(id);

              case 3:
                vali = _context2.sent;

                if (vali === true) {
                  _this2.$refs.TabelHeader.PrintOuterBoxLabel();
                } else {
                  _this2.$message.warning('请点击生成标签');
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 生成外箱标签
    onCreateOutBoxBarcode_OuterBoxLabelManagement: function onCreateOutBoxBarcode_OuterBoxLabelManagement() {
      this.$refs.EditTable.handleCreateOutBoxBarcode(this.$refs.TabelHeader.getData());
    },
    // 设置表头数据
    setTabelHeaderData: function setTabelHeaderData(data) {
      var _this3 = this;

      console.log('设置数据', data);
      this.TabelHeaderData = data;
      this.$nextTick(function () {
        _this3.$refs.TabelHeader.setFormData(data);

        _this3.$refs.EditTable.GetBoxCodeDetailList(data);

        _this3.$refs.EditTable.GetBoxCodeDetailPrintData(data);
      });
    },
    // 送货单dialog确定
    onDialogSubmit_OuterBoxLabelManagement: function onDialogSubmit_OuterBoxLabelManagement(selectRecords) {
      this.$refs.TabelHeader.setFormData(selectRecords);
    },
    // 选择送货单
    onSelectOrder_OuterBoxLabelManagement: function onSelectOrder_OuterBoxLabelManagement() {
      this.$refs.EditTable.ShowChangeOrderDialog();
    },
    // 保存
    onSave_OuterBoxLabelManagement: function onSave_OuterBoxLabelManagement() {
      this.$refs.TabelHeader.saveData();
    }
  },
  watch: {
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表-
          this.TabelHeaderData = null;
          this.isShowTabelHeader = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.TabelHeaderData = null;
          this.isShowTabelHeader = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowTabelHeader = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState']))
};